import React, { useEffect, useState } from "react";
import { Image, Table, Form, Row, Col } from "react-bootstrap";
import { useDispatch, useSelector } from "react-redux";
import { Menu, MenuItem } from "@material-ui/core";
import { FormControl, Select, InputLabel } from "@material-ui/core";
import { useHistory } from "react-router-dom";
import moment from "moment";
import isEmpty from "../../../../../store/validation/is-Empty";
import { get_pending_exp_activity } from "../../../../../store/actions/Experience/adminExperienceAction";
import BasicPagination from "../../../../Pagination/Pagination";
import NoContent from "../../../../reusableComponents/NoContentComponent";
import LeftSideNavigation from "../../../../vendorDashboardComponents/navigationSection/LeftSideNavigation";
import HomeReusableTopBarNavigation from "../../../superAdminReusable/superAdminHomeButton/HomeReusableTopBarNavigation";
import TableBody from "./TableBody";
import SelectFilter from "../../../../reusableComponents/selectFilter";
import { RightSideCountTop } from "../../superAdminReports/orderingReports/SuperAdminPendingOrderActivityReports";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import MainFilterSection from "../../../../reusableComponents/searchandfilters/MainFilterSection";

const AllExperienceDashboard = (props) => {
  const auth = useSelector((state) => state.auth);
  const [exps, setExps] = useState([]);
  const [isActive, setActive] = useState(false);
  const [search, setSearch] = useState("");
  const [filter, showFilter] = useState(false);
  const [filterDropDown, setFilterDropDown] = useState("");
  const [filtervalue, setFiltervalue] = useState("");
  const [dateQuery, setDateQuery] = useState({
    startDate: moment().subtract(30, "days").format("YYYY-MM-DD"),
    endDate: moment().format("YYYY-MM-DD"),
  });

  const onDateChangeHandler = (data, type) => {
    setDateQuery(data);
  };
  // for pagination //

  const [page, setPage] = useState(1);
  const [start, setStart] = useState(0);
  const [end, setEnd] = useState(10);

  const [fullData, setFullData] = useState([]);

  const handleBatchChange = (pageNo) => {
    var calcStart = pageNo * 10 - 10;
    setStart(calcStart);
    setEnd(pageNo * 10);
    setPage(pageNo);
  };

  const getData = async (e) => {
    let _d = await get_pending_exp_activity(auth?.user?.accessToken, e, dateQuery?.startDate, dateQuery?.endDate);
    setExps(_d);
  };

  useEffect(() => {
    if (!isEmpty(dateQuery)) {
      getData("ALL");
    }
  }, [dateQuery]);

  const onChangeRestaurantType = (e) => {
    setFilterDropDown(e.target.value);
  };

  const onFilterSave = (e) => {
    setFiltervalue(filterDropDown);
    showFilter(!filter);
  };

  /*********************************
   * @DESC SORT FILTER ACTION
   *********************************/
  const [anchorEl, setAnchorEl] = React.useState(null);
  const [userSort, setUserSort] = useState(0);
  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  let filteredData = exps;
  if (search) {
    let searchData = new RegExp(search, "i");
    filteredData = exps.filter((getall) => {
      if (searchData.test(getall?._id?.restaurant_name)) {
        return getall;
      } else {
        return false;
      }
    });
  }
  if (filtervalue) {
    if (filtervalue === "") {
      filteredData = exps;
    } else if (filtervalue !== "") {
      filteredData = exps.filter(
        (restaurant) =>
          restaurant._id &&
          restaurant?._id?.restaurant_type[0] &&
          restaurant?._id?.restaurant_type[0].title === filtervalue
      );
    }
  }
  if (userSort) {
    if (userSort === 1) {
      filteredData = exps.sort((a, b) => {
        let nameA = a && a?._id?.restaurant_name.toLowerCase(); // ignore upper and lowercase
        let nameB = b && b?._id?.restaurant_name.toLowerCase(); // ignore upper and lowercase
        if (nameA < nameB) {
          return -1;
        }
        if (nameA > nameB) {
          return 1;
        }
        return 0;
      });
    } else if (userSort === 2) {
      filteredData = exps.sort((a, b) => {
        let nameA = a && a._id?.restaurant_name.toLowerCase(); // ignore upper and lowercase
        let nameB = b && b._id?.restaurant_name.toLowerCase(); // ignore upper and lowercase
        if (nameA < nameB) {
          return 1;
        }
        if (nameA > nameB) {
          return -1;
        }
        return 0;
      });
    }
  }

  const [stats, setStats] = useState({
    pendingRequests: 0,
    noOfExps: 0,
    ticketBookingRequests: 0,
  });

  useEffect(() => {
    let _p = 0;
    let _e = 0;
    let _t = 0;
    for (let index = 0; index < exps.length; index++) {
      const exp = exps[index];
      _p = _p + parseInt(exp?.requests?.pendingReqs);
      _e = _e + parseInt(exp?.experienceId?.length);
      _t = _t + parseInt(exp?.requests?.requests);
    }
    setStats({
      ...stats,
      pendingRequests: _p,
      noOfExps: _e,
      ticketBookingRequests: _t,
    });
  }, [exps]);

  return (
    <div>
      <div>
        <div className="container-fluid">
          <div className="row">
            <div className="left-side-panel">
              <LeftSideNavigation displayLink={1} />
            </div>
            <div className="super-admin-right-side-panel">
              <HomeReusableTopBarNavigation displayText="Reports" />
              <div className="super-admin-inside-right-side-panel">
                <div className="d-flex justify-content-between align-items-center pt-4 pb-3">
                  <div className="f24_700_HelveticaNeue">
                    All Experiences Dashboard
                  </div>
                </div>

                <div className="row">
                  <div
                    className="col-5 d-flex justify-content-start align-items-center"
                    style={{ marginBottom: "1%" }}
                  >
                    <div
                      className={`newexpandablesearch mb-2 mr-2  ${
                        isActive ? "active" : null
                      }`}
                    >
                      <div className="searchicon">
                        <i
                          onClick={() => {
                            setActive(!isActive);
                            setSearch("");
                          }}
                          className="fa fa-search"
                          aria-hidden="true"
                          style={{ fontSize: "20px" }}
                        ></i>
                      </div>
                      <div className="input">
                        <Form.Control
                          type="text"
                          placeholder="Business Name"
                          className="newsearchinput"
                          value={search}
                          onChange={(e) => {
                            setSearch(e.target.value);
                          }}
                          style={{ borderRadius: "28px" }}
                        />
                        <i className="fa fa-timesw" aria-hidden="true"></i>
                      </div>
                    </div>
                    <div
                      className="f10-400"
                      align="center"
                      onClick={() => showFilter(!filter)}
                    >
                      <img
                        src={require("../../../../../assets/images/iconButton/filterbtn.svg")}
                        width="80px"
                      />
                    </div>
                    <div className="f10-400" align="center">
                      <div>
                        <div
                          className="f10-400"
                          align="center"
                          aria-controls="simple-menu"
                          aria-haspopup="true"
                          onClick={handleClick}
                        >
                          <img
                            src={require("../../../../../assets/images/iconButton/sortbtn.svg")}
                            width="80px"
                          />
                        </div>
                        <Menu
                          id="simple-menu"
                          anchorEl={anchorEl}
                          keepMounted
                          open={Boolean(anchorEl)}
                          onClose={handleClose}
                        >
                          {[
                            {
                              title: "Sort Business Name",
                              value: 0,
                              disabled: true,
                            },
                            {
                              title: `A-Z`,
                              value: 1,
                              disabled: false,
                            },
                            {
                              title: "Z-A",
                              value: 2,
                              disabled: false,
                            },
                          ].map((ele, index) => {
                            return (
                              <MenuItem
                                value={ele.value}
                                key={index}
                                onClick={() => setUserSort(ele.value)}
                                disabled={ele.disabled}
                                style={{ fontWeight: "700" }}
                              >
                                {ele.title}
                              </MenuItem>
                            );
                          })}
                        </Menu>
                      </div>
                    </div>
                    <div className="f10-400" align="center">
                      <img
                        src={require("../../../../../assets/images/iconButton/downloadbtn.svg")}
                        width="80px"
                        alt="icon"
                        title="Download"
                      />
                      <br />
                      {/* Download */}
                    </div>
                  </div>
                  <div
                    className="col-3 d-flex align-items-center"
                    style={{ paddingBottom: "15px" }}
                  >
                    {/* <div className="row w-100">
                      <div
                        className="col-5"
                        style={{ borderRight: "1px solid #E0E0E0" }}
                      >
                        <TableSizePopup
                          showPax={state.showPax}
                          onOpenModal={onOpenModalPax}
                          open={state.openPax}
                          onCloseModal={onCloseModalPax}
                          table_size={state.showPaxText}
                          onClickAll={(e) => bigButtonShowPaxHandler(e, "All")}
                          onClickTwo={(e) => bigButtonShowPaxHandler(e, "2")}
                          onClickFour={(e) => bigButtonShowPaxHandler(e, "4")}
                          onClickSix={(e) => bigButtonShowPaxHandler(e, "6")}
                          onClickEight={(e) => bigButtonShowPaxHandler(e, "8")}
                          graterThanEight={(e) =>
                            bigButtonShowPaxHandler(e, "8>")
                          }
                          selectPaxClick={selectPaxClick}
                        />
                      </div>
                    </div> */}
                  </div>
                  <div className="col-1 d-flex align-items-end">
                    {/* <div className="mr-3 w-100">
                      <FormControl variant="outlined" fullWidth>
                        <InputLabel id="demo-simple-select-outlined-label">
                          Select date range
                        </InputLabel>
                        <Select
                          labelId="demo-simple-select-outlined-label"
                          id="demo-simple-select-outlined"
                          value={""}
                          onChange={() => {}}
                          label="date_range"
                        >
                          <MenuItem value="">Last 30 days</MenuItem>
                        </Select>
                      </FormControl>
                    </div> */}
                  </div>
                  <div className="col-3 d-flex align-items-center justify-content-end">
                    <div className="mr-3">
                      <SelectFilter onDateChange={onDateChangeHandler} />
                    </div>
                  </div>
                </div>
                {filter && (
                  <div className="mt-3 mb-3">
                    <Row>
                      <div className="col-3">
                        <div className="mr-3">
                          <FormControl variant="outlined" fullWidth>
                            <InputLabel id="demo-simple-select-outlined-label">
                              Restaurant Type
                            </InputLabel>
                            <Select
                              labelId="demo-simple-select-outlined-label"
                              id="demo-simple-select-outlined"
                              name="restaurantType"
                              value={filterDropDown}
                              onChange={(e) => onChangeRestaurantType(e)}
                              label="date_range"
                            >
                              {" "}
                              {props.restaurant_type &&
                                props.restaurant_type.map((item, index) => (
                                  <MenuItem key={index} value={item.title}>
                                    {item.title}
                                  </MenuItem>
                                ))}
                            </Select>
                          </FormControl>
                        </div>
                      </div>
                    </Row>
                    <div class="d-flex align-items-center mt-2">
                      <button
                        type="button"
                        className="btn-md mr-4 px-5 btn btn-outline-secondary"
                        onClick={() => {
                          showFilter(!filter);
                          setFiltervalue("");
                        }}
                      >
                        Reset
                      </button>
                      <button
                        type="button"
                        className="btn-md px-5 btn btn-danger"
                        onClick={onFilterSave}
                      >
                        Apply Filter
                      </button>
                    </div>
                  </div>
                )}
                <hr />
                <div className="row d-flex justify-content-end">
                  <RightSideCountTop
                    content={[
                      {
                        name: "Pending Requests",
                        value: stats?.pendingRequests || 0,
                        backgroundColor: "#FFEDE9",
                        color: "#EE3A23",
                      },
                      {
                        name: "No. of Experiences",
                        value: stats?.noOfExps || 0,
                        backgroundColor: "#EFEBFB",
                        color: "#6F32C9",
                      },
                      {
                        name: "Ticket Booking Requests",
                        value: stats?.ticketBookingRequests || 0,
                        backgroundColor: "#D8F3F4",
                        color: "#138B90",
                      },
                    ]}
                  />
                </div>
                <div>
                  <div className="col-12 p-0 user-table-reusable-superadmin super-admin-all-vendor-main">
                    <Table className="">
                      <thead>
                        <tr className="super_admin_all_users_table_head">
                          <td style={{ width: "15%" }} className="f12-400">
                            Business <br />
                            ID
                          </td>
                          <td style={{ width: "15%" }} className="f12-400">
                            Business Name
                          </td>
                          <td style={{ width: "10%" }} className="f12-400">
                            No. of <br />
                            Experiences
                          </td>
                          <td style={{ width: "10%" }} className="f12-400">
                            Pending <br />
                            Requests
                          </td>
                          <td style={{ width: "10%" }} className="f12-400">
                            Ticket Booking <br />
                            Requests
                          </td>
                          <td style={{ width: "15%" }} className="f12-400">
                            Type of <br />
                            Establishment
                          </td>
                          <td style={{ width: "10%" }} className="f12-400">
                            Status
                          </td>
                          <td style={{ width: "15%" }} className="f12-400">
                            Actions
                          </td>
                        </tr>
                      </thead>
                      {filteredData?.length ? (
                        <React.Fragment>
                          {filteredData.slice(start, end).map((data, index) => {
                            return (
                              <React.Fragment key={index}>
                                <TableBody data={data} />
                              </React.Fragment>
                            );
                          })}
                          <BasicPagination
                            totalRecords={filteredData?.length || 0}
                            limit={10}
                            batch={page}
                            onBatchChange={(e) => handleBatchChange(e)}
                          />
                        </React.Fragment>
                      ) : (
                        <NoContent />
                      )}
                    </Table>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

const mapStateToProps = (state) => ({
  restaurant_type: state.category.restaurant_type,
});

export default connect(mapStateToProps)(withRouter(AllExperienceDashboard));

//export default AllExperienceDashboard;
